import ConfirmModal from './ConfirmModal';
import ErrorModal from './ErrorModal';

const Modal = {
  confirm: ConfirmModal,
  error: ErrorModal
};

export default Modal;
